const items = [
  "WEB DEVELOPMENT",
  "SAAS SOLUTIONS",
  "AI & AUTOMATION",
  "WEB APPS",
  "BUSINESS SYSTEMS",
  "WORKFLOW AUTOMATION",
  "AI INTEGRATIONS",
  "UI / UX",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="section-marquee"
      className="relative border-y border-[var(--border-dim)] bg-[var(--bg)] overflow-hidden"
    >
      <div className="marquee-inner flex whitespace-nowrap gap-12 py-6">
        {row.map((it, i) => (
          <span
            key={i}
            className="font-display font-black text-3xl md:text-5xl tracking-tight"
          >
            <span className={i % 2 === 0 ? "text-[var(--text-1)]" : "text-[var(--vermilion)]"}>
              {it}
            </span>
            <span className="text-[var(--lime)] mx-6">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
